export default "__VITE_ASSET__225e2920__"